module.exports = __webpack_public_path__ + "img/pdf.f3db134a.png";